import React from "react";
import { ArticleContact } from "../../../../../amorg-common";
import { colors } from "../../../../../designSystem/colors/color";
import { Flex, FlexItem } from "../../../../../designSystem/compositeComponents/FlexHelpers";
import { ListRow } from "../../../../../designSystem/compositeComponents/ListRow";
import { Label } from "../../../../../designSystem/Label";
import { Small } from "../../../../../designSystem/typography/Body";

type ArticleViewContactsPanelProps = {
    contacts: ArticleContact[];
};
export function ArticleViewContactsPanel (props: ArticleViewContactsPanelProps): JSX.Element
{
    return (
        <ListRow styleVariant='outlined' level={2} stripColor={props.contacts.length === 0 ? colors.icon.passive : colors.icon.active}
            content={
                <Flex flexDirection='column'>
                    <FlexItem flexGrow='1'>
                        {props.contacts.length === 0
                            ? <i>Ingen kontaktpersoner oprettet</i>
                            : <Label>Kontaktperson(er) ({props.contacts.length})</Label>
                        }
                    </FlexItem>
                    
                    {props.contacts.map((contact) =>
                        <div key={contact.siteUserId}>
                            <Small>{contact.name} ({contact.email})</Small>
                        </div>
                    )}
                </Flex>
            } />
    );
}